// What is wrong with a corrido picture or clip, as one-tap chips (the learning
// loop, docs/corrido-learning-loop.md). The ids are the contract with the
// server's list, FaceShot-ChopShop-web/shared/corrido-learning/reasons.json: a
// Node test reads THIS file as text and compares the ids and flags, so keep
// one entry per line in the `{ id: "...", stills: ..., clips: ... }` form.
// Labels live in the locales under corridoReasons.<id> (en + es).
//
// A reason never changes what a redraw draws; it only teaches the tool what to
// avoid. The server drops unknown ids silently and keeps at most 6 per take.

export type CorridoReasonKind = "stills" | "clips";

export type CorridoReason = { id: string; stills: boolean; clips: boolean };

export const CORRIDO_REASONS: readonly CorridoReason[] = [
  { id: "face", stills: true, clips: true },
  { id: "body", stills: true, clips: true },
  { id: "gun", stills: true, clips: true },
  { id: "object", stills: true, clips: true },
  { id: "fake", stills: true, clips: true },
  { id: "motion", stills: false, clips: true },
  { id: "dark", stills: true, clips: true },
  { id: "vibe", stills: true, clips: true },
  { id: "repeat", stills: true, clips: true },
];

/** At most this many reasons per take (the server keeps no more). */
export const MAX_REASONS = 6;

/** The reason ids offered for a picture ("stills") or an animated clip ("clips"), in display order. */
export function reasonIdsFor(kind: CorridoReasonKind): string[] {
  return CORRIDO_REASONS.filter((r) => r[kind]).map((r) => r.id);
}

/** Known ids only, each once, in the order picked, at most MAX_REASONS. With a
 *  kind, ids that do not apply to it (motion on a still) are dropped too. */
export function cleanReasons(list: readonly unknown[] | null | undefined, kind?: CorridoReasonKind): string[] {
  if (!Array.isArray(list)) return [];
  const allowed = new Set(kind ? reasonIdsFor(kind) : CORRIDO_REASONS.map((r) => r.id));
  const out: string[] = [];
  for (const id of list) {
    if (typeof id !== "string" || !allowed.has(id) || out.includes(id)) continue;
    out.push(id);
    if (out.length >= MAX_REASONS) break;
  }
  return out;
}
